import { render, staticRenderFns } from "./harmony.vue?vue&type=template&id=45fc89b6&scoped=true"
var script = {}
import style0 from "./harmony.vue?vue&type=style&index=0&id=45fc89b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fc89b6",
  null
  
)

export default component.exports